import { Component, OnInit, Input, AfterViewInit, ViewChild, ElementRef} from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '../../../services/storage.service';
import { ComprovanteService } from '../../../services/comprovante.service';
import { EleicaoService } from '../../../services/eleicao.service';
import { Eleicao } from '../../../models/eleicao.model';
import { Resultado } from 'src/app/models/resultado.model';
import { Comprovante } from 'src/app/models/comprovante.model';
import { NgxSpinnerService } from 'ngx-spinner'
import { LoginService } from 'src/app/services/login.service';
import { CargoService } from 'src/app/services/cargo.service';
import { Cargo } from 'src/app/models/cargo.model';

@Component({
  selector: 'app-comprovante-voto',
  templateUrl: './comprovante-voto.component.html',
  styleUrls: ['./comprovante-voto.component.css']
})
export class ComprovanteVotoComponent implements OnInit, AfterViewInit {

  @ViewChild('printButton', { static: false }) printButton: ElementRef<HTMLButtonElement>;
  @Input() eleicao: Eleicao;
  @Input() isManager: boolean;

  public token: any;
  private localUser: any;
  public comprovantes: Comprovante[];
  public resultados: Resultado;
  infoEleitor: any;
  private dataLoaded: boolean = false;

  constructor(
    protected comprovanteServices: ComprovanteService,
    protected loginService: LoginService,
    protected storage: StorageService,
    protected router: Router,
    public spinner: NgxSpinnerService,
    protected eleicaoServices: EleicaoService,
    protected cargoService : CargoService
  ) { }

  async ngOnInit() {
    this.comprovantes = new Array;
    this.token = sessionStorage.getItem("token");
    this.localUser = JSON.parse(sessionStorage.getItem("infoEleitor"));

    if (!this.eleicao && this.localUser && this.localUser.sub) {
      this.getEleicao(this.localUser.idEleicao, this.token);
      this.getComprovante(this.localUser.id, this.token);
    }

    this.dataLoaded = true; 
  }

  ngAfterViewInit() {
    if (this.printButton) {
      this.setupEventListeners();
    } else {
      const interval = setInterval(() => {
        if (this.printButton) {
          this.setupEventListeners();
          clearInterval(interval);
        }
      }, 100);
    }
  }

  setupEventListeners() {
    if (this.printButton) {
      const button = this.printButton.nativeElement;
      const tituloOriginal = document.title;
      const tituloComprovante = "Comprovante de Voto";

      button.addEventListener('click', () => {
        document.title = tituloComprovante;
        window.print();
      });

      window.addEventListener('beforeprint', () => {
        document.title = tituloComprovante;
      });

      window.addEventListener('afterprint', () => {
        document.title = tituloOriginal;
      });
    }
  }


  getEleicao(idEleicao: number, token: any) {
    this.eleicaoServices.getById(idEleicao, token).then((eleicao: Eleicao) => {
      this.eleicao = eleicao;
    }).catch(err => {
      //this.router.navigate(['/error-sessao']);
    });
  }

  getComprovante(idEleitor: number, token: any) {
    this.comprovanteServices.getComprovanteVotoPorIdEleitor(idEleitor, token).then((comprovantes: Comprovante[]) => {
      this.comprovantes = comprovantes;
      this.getNomeCargos(this.comprovantes, token)
      this.spinner.hide();
    }).catch(err => {
      //this.router.navigate(['/error-sessao']);
    });
  }

  getNomeCargos(comprovantes: any, token: any) {
    comprovantes.forEach(comprovante => {
      this.cargoService.getByIdCargo(comprovante.cargoId, token).then((data: any) => {
        comprovante.cargoNome = data.nome;
      });
    }
    )
  }

  printPage() {
  }

  
}
